import { render, staticRenderFns } from "./PictureFileForm.vue?vue&type=template&id=cfb12e24"
import script from "./PictureFileForm.vue?vue&type=script&lang=js"
export * from "./PictureFileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports